module.exports = __webpack_public_path__ + "static/media/BBB@2x.ac72bb70.png";